import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const serviceFeeEndpoint = ENDPOINTS.SERVICEFEE;

// Category API
export const serviceFeeApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["serviceFees"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getServiceFees: builder.query({
        query: (payload) => `${serviceFeeEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "serviceFees" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      addServiceFee: builder.mutation({
        query: (requestData) => ({
          url: `${serviceFeeEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "serviceFees" }],
      }),
      deleteServiceFee: builder.mutation({
        query: (id) => ({
          url: `${serviceFeeEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "serviceFees" }],
      }),
      updateServiceFee: builder.mutation({
              query: ({id, requestData}) => ({
                url: `${serviceFeeEndpoint}/${id}`,
                method: METHODS.PUT,
                body: requestData,
              }),
              invalidatesTags: () => [{ type: "serviceFees" }],
            }),
    }),
  });

// Export hooks for usage in components

export const { useAddServiceFeeMutation, useGetServiceFeesQuery, useDeleteServiceFeeMutation, useUpdateServiceFeeMutation } = serviceFeeApi;
